import React from 'react'
import { ErrorModal } from './../../ui'
import { subscriptionHelpers } from '../../../dataHelpers'
import { getStorage, TOKEN_STORAGE_KEY, authRedirect } from '../../../dataHelpers/authenticationHelpers'
import { Table } from 'reactstrap'
import '../../../stylesheets/Provision.css'
import { Nav, NavItem, NavLink } from 'reactstrap'
import EditPlanIcon from 'react-icons/lib/fa/edit'
import AddPlanIcon from 'react-icons/lib/fa/plus-square'
import SubsListIcon from 'react-icons/lib/fa/list'
import classnames from 'classnames'
import tapOrClick from 'react-tap-or-click'
import Loader from 'react-loader-spinner'

class TeamDiscountList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            loading: false,
            activeTab: '3',
            allDiscountData: []
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.fetchAllDiscountList = this.fetchAllDiscountList.bind(this)
    }

    async componentDidMount() {
        if (this.token) {
            this.fetchAllDiscountList()
        }
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }

    async fetchAllDiscountList() {
        this.setState({ loading: true })
        let allDiscountList = await subscriptionHelpers.getAllAssignedDiscountList(this.token)
        if (!allDiscountList.error) {
            this.setState({ allDiscountData: allDiscountList, loading: false })
        } else {
            this.setState({ errors: [allDiscountList.error] })
        }
    }

    render() {
        let { errors, loading, allDiscountData } = this.state
        return (<div>
            <div className="m-0 p-0">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/discountsetting`, this.props.history)) })}
                        >
                            <AddPlanIcon />&ensp;Assign Discount to Team
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/editassigneddiscount`, this.props.history)) })}
                        >
                            <EditPlanIcon />&ensp;Edit Assigned Discount
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '3' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/teamdiscountlist`, this.props.history)) })}>
                            <SubsListIcon />&ensp;Assigned Discount List
                            </NavLink>
                    </NavItem>
                </Nav>
            </div>
            <div className="row justify-content-center align-items-center bg-light large-rounded border-light-sf-orange p-0 pb-4">
                <h1 className="text-center mb-4 form-head col-12">Assigned Discount Levels</h1>
                {loading ?
                    <Loader type="TailSpin" width={60} height={60} /> :
                    <div className="discount-assign-list">
                        <Table>
                            <thead>
                                <tr>
                                    <th>Team</th>
                                    <th>Discount (%)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allDiscountData ? allDiscountData.map((discountdata) => (
                                    <tr key={discountdata.team.id}>
                                        <td>
                                            {discountdata.team.name}
                                        </td>
                                        <td>{discountdata.discount.discount}</td>
                                    </tr>
                                )) :
                                    ''}
                            </tbody>
                        </Table>
                    </div>
                }
                {errors.map((appError, idx) =>
                    <ErrorModal key={`error-${appError.text}-${idx}`}
                        modal={true}
                        toggle={() => (this.dismissError(appError))}
                        text={appError.text}
                        title={appError.title} />
                )}
            </div>
        </div>)
    }
}
export default TeamDiscountList



// WEBPACK FOOTER //
// ./src/components/pages/subscription/TeamDiscountList.js